import React from 'react';
import { TfiReload } from 'react-icons/tfi';

const HistoricoSection = ({ historico, selectedDate, onDateChange, onRefresh, isSpinningHistorico }) => {
  return (
    <>
      {/* Toolbar do histórico - segue padrão feature-control-bar */}
      <div className="historico-toolbar">
        <h2 className="historico-toolbar__title">Histórico de Ações</h2>
        <div className="historico-toolbar__end">
          <input
            type="date"
            className="historico-toolbar__date"
            value={selectedDate}
            onChange={(e) => onDateChange(e.target.value)}
          />
          <button 
            className="historico-toolbar__refresh" 
            onClick={onRefresh} 
            title="Atualizar Histórico"
          >
            <TfiReload size={16} className={`refresh-icon ${isSpinningHistorico ? 'spinning' : ''}`} />
          </button>
        </div>
      </div>
      
      {/* Corpo da tabela */}
      <div className={`historico-body ${isSpinningHistorico ? 'loading-animation' : ''}`}>
        <div className="action-log-table-container">
          <table>
            <thead>
              <tr>
                <th>Requerente</th>
                <th>Apto</th>
                <th>Bloco</th>
                <th>Final</th>
                <th>Ação</th>
                <th>Data e Hora</th>
              </tr>
            </thead>
            <tbody>
              {historico.length > 0 ? (
                historico.map((acao) => (
                  <tr key={acao.id}>
                    <td>{acao.requerente}</td>
                    <td>{acao.apto || '-'}</td>
                    <td>{acao.bloco}</td>
                    <td>{acao.final || '-'}</td>
                    <td data-action={acao.acao}>{acao.acao}</td>
                    <td>{new Date(acao.executado_em).toLocaleString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="historico-empty">Nenhum registro encontrado para a data selecionada.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default HistoricoSection;
